export default {
    methods: {
        isUserAgentValid() {
            const userAgent = navigator.userAgent;

            if (userAgent) {
                const refusedBrowserRegex = [/trident\//i, /msie /i];

                return !refusedBrowserRegex.some((regex) => userAgent.match(regex));
            }

            return false;
        },
    },
};
